// extracted by mini-css-extract-plugin
export var logo = "Logos-module--logo--ad58d";
export var logoBox = "Logos-module--logoBox--34263";
export var logosContainer = "Logos-module--logosContainer--9a967";